import { render, staticRenderFns } from "./ClientTypeDash.vue?vue&type=template&id=7ae5dcf6&"
import script from "./ClientTypeDash.vue?vue&type=script&lang=js&"
export * from "./ClientTypeDash.vue?vue&type=script&lang=js&"
import style0 from "./ClientTypeDash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports